import React from 'react';

export const BankCardIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      viewBox='0 0 28 22'
      focusable='false'
      width={width}
      height={height}
      className='icon icon-bank-card'
      {...rest}
    >
      <path
        fill={fill}
        d='M24.75 1.83167e-05H2.74999C2.38925 -0.00091769 2.0319 0.069677 1.69862 0.20772C1.36533 0.345762 1.06272 0.548513 0.808294 0.804246C0.553864 1.05998 0.35266 1.36362 0.21632 1.6976C0.0799806 2.03159 0.0112106 2.38929 0.0139877 2.75002L-1.22008e-05 19.25C-0.00133399 19.6115 0.0688946 19.9697 0.206627 20.304C0.344359 20.6382 0.546872 20.9419 0.802497 21.1975C1.05812 21.4531 1.3618 21.6556 1.69605 21.7934C2.03029 21.9311 2.38848 22.0013 2.74999 22H24.75C25.1115 22.0013 25.4697 21.9311 25.8039 21.7934C26.1382 21.6556 26.4419 21.4531 26.6975 21.1975C26.9531 20.9419 27.1556 20.6382 27.2934 20.304C27.4311 19.9697 27.5013 19.6115 27.5 19.25V2.75002C27.5013 2.38851 27.4311 2.03032 27.2934 1.69608C27.1556 1.36183 26.9531 1.05815 26.6975 0.802528C26.4419 0.546903 26.1382 0.34439 25.8039 0.206658C25.4697 0.0689253 25.1115 -0.00130347 24.75 1.83167e-05ZM24.75 19.25H2.74999V11H24.75V19.25ZM24.75 5.50002H2.74999V2.75002H24.75V5.50002Z'
      />
    </svg>
  );
};

BankCardIcon.defaultProps = {
  width: 28,
  height: 22,
  fill: 'currentColor'
};
